import React, { Component } from 'react'
import { Trans } from "react-i18next";

export default class AppCard extends Component {
    render() {
        return (
            <div className="card custom-width border-round h-100 box-shadow">
                <div className='header img-header p-3'>
                    <img src={this.props.app.logo} className="card-img-top img-fluid" alt="logo" />
                </div>
                <div className="card-body">
                    <h5 className="card-title">{this.props.app.name.toUpperCase()}</h5>
                    <p className="card-text">{this.props.app.description}</p>
                    <a href={this.props.app.path} className="btn btn-primary btn-align-end"><Trans>card.btn.go</Trans></a>
                </div>
            </div>
        )
    }
}
